import { createSlice } from '@reduxjs/toolkit';
import { 
    addShop, 
    getShopMainCategory,
    getShopSubCategory,
    getAllategory,
    addShopcontent,
    getShopImagesbyID,
    shopStatusChange,
    getPaginateShops,
    getShopsOfcView,
    getShopContntBytrns,
    getShopContentbyID,
    getShopAdressbyID,
    getShopAdressBytrns,
    getShopContctInfobyID,
    getShopCntInfoBytrns,
    getShopTimeInfobyID,
    getShopTimeInfoByDayID,
    homeLoadShops

    
 } from '../actions/shopAction';

export const shopReducerSlice = createSlice({
    name:'shopReducer',
    initialState:{
        homeSort:{
            sortby:"_id",
            order:"desc",
            limit:10,
            skip:0
        },
        loading:false,
        shops:[],
        current:null,
        mCategories:[],
        sCategories:[],
        images:[],
        currentContent:null,
        currentAdress:null,
        currentCntInfo:null,
        currentTimenfo:null

    },
    reducers:{

        updateCategories:(state,action)=>{
            state.mCategories = action.payload
        }
    }
 ,extraReducers:(builder)=>{
    builder
    // ADD SHOP
    .addCase(addShop.pending,(state)=>{ state.loading = true })
    .addCase(addShop.fulfilled,(state,action)=>{ 
        state.loading = false;
        state.lastAdded = action.payload 
    })
    .addCase(addShop.rejected,(state)=>{ state.loading = false })

       

  


 /// adding main CATEGORY
 .addCase(getShopMainCategory.fulfilled,(state,action)=>{ 
    console.log("1111");
    console.log(action.payload);
    console.log("1111");
    state.mCategories = action.payload;

    console.log("444555");
    console.log(state.mCategories);
    console.log("333");

    
})

//ADDING SUB CATEGORY 
 /// adding main CATEGORY
 .addCase(getShopSubCategory.fulfilled,(state,action)=>{ 
    console.log("1111");
    console.log(action.payload);
    console.log("1111");
    state.sCategories = action.payload;

    console.log("444555");
    console.log(state.mCategories);
    console.log("333");

    
})

//GETTING ALL CATEGORIES AND SUBcATEGORIES

.addCase(getAllategory.fulfilled,(state,action)=>{ 
    console.log("1111");
    console.log(action.payload);
    console.log("1111");
    state.mCategories = action.payload;

    console.log("444555");
    console.log(state.mCategories);
    console.log("333");

    
})

//ADDING SHOP CONTENT TO THE EXSITING SHOP

.addCase(addShopcontent.pending,(state)=>{ state.loading = true })
    .addCase(addShopcontent.fulfilled,(state,action)=>{ 
        state.loading = false;
        state.lastAdded = action.payload 
    })
    .addCase(addShopcontent.rejected,(state)=>{ state.loading = false })

    

    /// IMAGES LIST
// .addCase(getShopImagesbyID.fulfilled,(state,action)=>{ 
//     state.images = action.payload.imageList;
//     //state.current= action.payload.imageList;

//     console.log("22222");
//     console.log(action.payload.imageList);
//     console.log("22222");
// })


.addCase(getShopImagesbyID.pending,(state)=>{ state.loading = true })
.addCase(getShopImagesbyID.fulfilled,(state,action)=>{ 
    console.log("999999999999");
    console.log(action.payload.imageList);
    console.log("999999999999");
    state.loading = false;
    


    //state.current = action.payload;
    

    
    state.images =action.payload.imageList;
    console.log("99999999999955555");
    console.log(state.images);
    console.log("99999999999955555");
})
.addCase(getShopImagesbyID.rejected,(state)=>{ state.loading = false })



.addCase(shopStatusChange.fulfilled,(state,action)=>{ 
    state.images = action.payload.images;

 
})
  // GET PAGINATE ARTICLES
  .addCase(getPaginateShops.pending,(state)=>{ state.loading = true })
  .addCase(getPaginateShops.fulfilled,(state,action)=>{ 
    state.loading = false;
    console.log("444555");
    console.log(action.payload);
    console.log("333");
   
      state.shops= action.payload 

      console.log(state.shops);
    console.log("333");
  })
  .addCase(getPaginateShops.rejected,(state)=>{ state.loading = false })

  //getShopDetailsforOfcUse
.addCase(getShopsOfcView.pending,(state)=>{ state.loading = true })
.addCase(getShopsOfcView.fulfilled,(state,action)=>{ 
    console.log("999999999999");
    console.log(action.payload);
    console.log("999999999999");
    state.loading = false;
    state.current = action.payload
})
.addCase(getShopsOfcView.rejected,(state)=>{ state.loading = false })
//geting shop content by shop id and trans no


.addCase(getShopContntBytrns.pending,(state)=>{ state.loading = true })
.addCase(getShopContntBytrns.fulfilled,(state,action)=>{ 
    console.log("999999999999");
    console.log(action.payload);
    console.log("999999999999");
    state.loading = false;
    state.getShopContntBytrns = action.payload
})
.addCase(getShopContntBytrns.rejected,(state)=>{ state.loading = false })


//getShopContentByIDOfcUse
.addCase(getShopContentbyID.pending,(state)=>{ state.loading = true })
.addCase(getShopContentbyID.fulfilled,(state,action)=>{ 
    console.log("999999999999");
    console.log(action.payload);
    console.log("999999999999");
    state.loading = false;
    state.currentContent = action.payload
})
.addCase(getShopContentbyID.rejected,(state)=>{ state.loading = false })


//getAdressByIDOfcUse
.addCase(getShopAdressbyID.pending,(state)=>{ state.loading = true })
.addCase(getShopAdressbyID.fulfilled,(state,action)=>{ 
    console.log("999999999999");
    console.log(action.payload);
    console.log("999999999999");
    state.loading = false;
    state.currentAdress = action.payload
})
.addCase(getShopAdressbyID.rejected,(state)=>{ state.loading = false })


//geting shop adress by shop id and trans no


.addCase(getShopAdressBytrns.pending,(state)=>{ state.loading = true })
.addCase(getShopAdressBytrns.fulfilled,(state,action)=>{ 
    console.log("999999999999");
    console.log(action.payload);
    console.log("999999999999");
    state.loading = false;
    state.getShopAdressBytrns = action.payload
})
.addCase(getShopAdressBytrns.rejected,(state)=>{ state.loading = false })

//getContactInfoByIDOfcUse
.addCase(getShopContctInfobyID.pending,(state)=>{ state.loading = true })
.addCase(getShopContctInfobyID.fulfilled,(state,action)=>{ 
    console.log("999999999999");
    console.log(action.payload);
    console.log("999999999999");
    state.loading = false;
    state.currentCntInfo = action.payload
})
.addCase(getShopContctInfobyID.rejected,(state)=>{ state.loading = false })



//geting shop Contact by shop id and trans no


.addCase(getShopCntInfoBytrns.pending,(state)=>{ state.loading = true })
.addCase(getShopCntInfoBytrns.fulfilled,(state,action)=>{ 
    console.log("999999999999");
    console.log(action.payload);
    console.log("999999999999");
    state.loading = false;
    state.getShopCntInfoBytrns = action.payload
})
.addCase(getShopCntInfoBytrns.rejected,(state)=>{ state.loading = false })



//getTimmingInfoByIDOfcUse

.addCase(getShopTimeInfobyID.pending,(state)=>{ state.loading = true })
.addCase(getShopTimeInfobyID.fulfilled,(state,action)=>{ 
    console.log("999999999999");
    console.log(action.payload);
    console.log("999999999999");
    state.loading = false;
    state.currentTimenfo = action.payload
})
.addCase(getShopTimeInfobyID.rejected,(state)=>{ state.loading = false })


//geting shop time by shop id and day  no

.addCase(getShopTimeInfoByDayID.pending,(state)=>{ state.loading = true })
.addCase(getShopTimeInfoByDayID.fulfilled,(state,action)=>{ 
    console.log("999999999999");
    console.log(action.payload);
    console.log("999999999999");
    state.loading = false;
    state.getShopTimeInfoByDayID = action.payload
})
.addCase(getShopTimeInfoByDayID.rejected,(state)=>{ state.loading = false })


// HOME LOAD MORE
.addCase(homeLoadShops.fulfilled,(state,action)=>{ 

    console.log("77777777777");
    state.homeSort.skip = action.payload.sort.skip
    state.shops = action.payload.newState
})





//end

}
})




 

export const { updateMnCategories } = shopReducerSlice.actions
export default shopReducerSlice.reducer;
